module.exports = __webpack_public_path__ + "static/media/proactive.dd80c192.jpg";